// Reusable password input with show/hide toggle.
// Default state: hidden. Toggle swaps type between "password" and "text".
// Eye/EyeOff icon is positioned inside the field on the right with a 40px
// touch target and an accessible label that flips with state.
import * as React from "react";
import { Eye, EyeOff } from "lucide-react";

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> & {
  style?: React.CSSProperties;
};

export const PasswordInput = React.forwardRef<HTMLInputElement, Props>(
  function PasswordInput({ style, ...inputProps }, ref) {
    const [visible, setVisible] = React.useState(false);
    const mergedInputStyle: React.CSSProperties = {
      ...style,
      // Leave room for the toggle button (40px) + a small gap.
      paddingRight: 46,
      width: "100%",
      boxSizing: "border-box",
    };
    return (
      <div style={{ position: "relative", width: "100%" }}>
        <input
          {...inputProps}
          ref={ref}
          type={visible ? "text" : "password"}
          style={mergedInputStyle}
        />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Hide password" : "Show password"}
          aria-pressed={visible}
          tabIndex={0}
          style={{
            position: "absolute",
            top: "50%",
            right: 4,
            transform: "translateY(-50%)",
            width: 40,
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "transparent",
            border: "none",
            padding: 0,
            cursor: "pointer",
            color: "#7A5A66",
            borderRadius: 8,
          }}
        >
          {visible ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
    );
  },
);
